module.exports = __webpack_public_path__ + "static/media/hardware_icon.c7c9f4e6.svg";